import ForwardTracker from "../../../../../prop-trackers/forward-tracker.js";
import ValueTracker from "../../../../../prop-trackers/value-tracker.js";
import { Mapper, ValueMapper } from "../../../../../prop-tracker-utils/mapper.js";

class TrackIndexer extends ForwardTracker {
    constructor(animTracker) {
        const mapper = new Mapper(animTracker, (key) => new AnimMapper());
        super(mapper);
    }
}

class AnimMapper extends ValueMapper {
    constructor() {
        super();

        this._outputTracker = new ValueTracker();

        const needsUpdate = () => this.protected_needsUpdate();
        this._outputTracker.listenNeedsUpdate(needsUpdate);
    }

    setValue(animation) {
        const trackIndexData = {};

        for (const [index, track] of animation.tracks.entries()) {
            const parsedPath = THREE.PropertyBinding.parseTrackName(track.name);
            const { nodeName, objectName, objectIndex, propertyName, propertyIndex } = parsedPath;

            if (objectName === undefined && objectIndex === undefined && propertyIndex === undefined) {
                let objTrackIndices = trackIndexData[nodeName];
                if (!objTrackIndices) {
                    objTrackIndices = {};
                    trackIndexData[nodeName] = objTrackIndices;
                }

                if (propertyName in objTrackIndices) {
                    console.warn(`Index already taken for track name: ${track.name}`);
                } else {
                    objTrackIndices[propertyName] = index;
                }
            } else {
                console.warn(`Unrecognized animation track name: ${track.name}`);
            }
        }

        this._outputTracker.setValue(trackIndexData);
    }

    deleteValue() {
        this._outputTracker.deleteValue();
    }

    protected_startUpdate() {
        return this._outputTracker.startUpdate();
    }

    protected_finishUpdate() {
        return this._outputTracker.finishUpdate();
    }
}

export default TrackIndexer;
